import isEmpty from "./is-Empty";

const getSellerDefaultAddress = (addresses, auth) => {
  if (addresses?.data?.length > 0) {
    if (auth?.user?.roles_type?.role_type_name === "DISTRIBUTOR") {
      let mWareHouseAddress = addresses.data.find((el) => el.set_default === 1);
      if (isEmpty(mWareHouseAddress)) {
        mWareHouseAddress = addresses.data.find(
          (el) => el.address_type_id.type_name.toLowerCase() === "warehouse"
        );
      }
      if (isEmpty(mWareHouseAddress)) {
        mWareHouseAddress = addresses.data.find(
          (el) => el.address_type_id.type_name.toLowerCase() === "billing"
        );
      }
      return mWareHouseAddress;
    } else if (auth?.user?.roles_type?.role_type_name === "MANUFACTURER") {
      let mFactoryAddress = addresses.data.find((el) => el.set_default === 1);
      if (isEmpty(mFactoryAddress)) {
        mFactoryAddress = addresses.data.find(
          (el) => el.address_type_id.type_name.toLowerCase() === "factory"
        );
      }
      if (isEmpty(mFactoryAddress)) {
        mFactoryAddress = addresses.data.find(
          (el) => el.address_type_id.type_name.toLowerCase() === "billing"
        );
      }
      return mFactoryAddress;
    }
  }

  return null;
};
export default getSellerDefaultAddress;
